// Render an HTML document into a hidden iframe and print it — keeps the
// print pipeline isolated from the app DOM (same pattern as the owner
// letter) without leaving an extra browser tab open.
export function printHtmlViaIframe(html, frameId = "__print_html_frame__") {
  let frame = document.getElementById(frameId);
  if (frame) frame.remove();
  frame = document.createElement("iframe");
  frame.id = frameId;
  frame.style.position = "fixed";
  frame.style.right = "0";
  frame.style.bottom = "0";
  frame.style.width = "0";
  frame.style.height = "0";
  frame.style.border = "0";
  frame.setAttribute("aria-hidden", "true");
  document.body.appendChild(frame);
  const doc = frame.contentDocument || frame.contentWindow?.document;
  if (!doc) return false;
  doc.open();
  doc.write(html);
  doc.close();
  const cw = frame.contentWindow;
  cw.addEventListener("afterprint", () => frame.remove(), { once: true });
  setTimeout(() => {
    cw.focus();
    cw.print();
  }, 200);
  return true;
}
